class TrPredictiveSearch extends HTMLElement {
	selectors = {
		searchForm: '[data-tr-js-predictive-search-form]',
		queryInput: '[data-tr-js-predictive-search-input]',
		results: '[data-tr-js-predictive-search-results]'
	};

	attributes = {};

	stateClasses = {};

	connectedCallback() {
		this.searchFormElement = document.querySelector(this.selectors.searchForm);
		this.queryInputElement = this.searchFormElement.querySelector(
			this.selectors.queryInput
		);
		this.resultsElement = this.querySelector(this.selectors.results);
		this.featuresElement = document.getElementById('shopify-features');

		if (!this.shadowRoot) {
			this.attachShadow({ mode: 'open' });
			this.shadowRoot.appendChild(
				document
					.createRange()
					.createContextualFragment('<slot name="results"></slot>')
			);
		}

		this.init();
		this.bindEvents();
	}

	disconnectedCallback() {
		this.destroy();
	}

	init() {
		this.predictiveSearchEnabled = JSON.parse(
			this.featuresElement.textContent
		).predictiveSearch;
	}

	bindEvents() {
		this.searchFormElement.addEventListener('submit', this.onFormSubmitted);
		this.searchFormElement.addEventListener('reset', this.onSearchCleared);
		this.queryInputElement.addEventListener('input', this.onInputChanged);
	}

	onInputChanged = () => {
		window.clearTimeout(this.searchTimeout);

		if (this.queryInputElement.value === '') {
			this.onSearchCleared();
			return;
		}

		this.fetchAbortController?.abort();
		this.fetchAbortController = new AbortController();
		this.searchTimeout = window.setTimeout(this.fetchResults, 280);
	};

	onFormSubmitted = (event) => {
		if (this.queryInputElement.value === '') {
			event.preventDefault();
		}
	};

	fetchResults = async () => {
		document.documentElement.dispatchEvent(
			new CustomEvent('theme:loading:start', { bubbles: true })
		);

		try {
			const searchUrl = `${window.Shopify.routes.root}search${
				this.predictiveSearchEnabled ? '/suggest' : ''
			}`;
			const queryParameters = `q=${encodeURIComponent(
				this.queryInputElement.value
			)}&section_id=tr-predictive-search&resources[limit]=10&resources[limit_scope]=each`;
			const response = await fetch(`${searchUrl}?${queryParameters}`, {
				signal: this.fetchAbortController.signal
			});
			const temporaryDocument = new DOMParser().parseFromString(
				await response.text(),
				'text/html'
			);
			const sectionElement = temporaryDocument.querySelector('.shopify-section');

			if (sectionElement) {
				this.resultsElement.replaceChildren(
					...document.importNode(sectionElement, true).children
				);
			}
		} catch (error) {
			if (error.name !== 'AbortError') {
				throw error;
			}
		} finally {
			document.documentElement.dispatchEvent(
				new CustomEvent('theme:loading:end', { bubbles: true })
			);
		}
	};

	onSearchCleared = () => {
		window.clearTimeout(this.searchTimeout);
		this.fetchAbortController?.abort();
		this.queryInputElement.focus();
		this.resultsElement.replaceChildren();
	};

	destroy() {
		window.clearTimeout(this.searchTimeout);
		this.fetchAbortController?.abort();
		this.searchFormElement.removeEventListener('submit', this.onFormSubmitted);
		this.searchFormElement.removeEventListener('reset', this.onSearchCleared);
		this.queryInputElement.removeEventListener('input', this.onInputChanged);
	}
}

customElements.define('tr-predictive-search', TrPredictiveSearch);
